import { Options, createStorage } from './storageCache'

function getStorageShorName() {
  return 'sop_test_admin'
}

const createOptions = (storage: Storage, options: Options = {}): Options => {
  return {
    storage,
    prefixKey: getStorageShorName(),
    ...options
  }
}

export const WebStorage = createStorage(createOptions(sessionStorage))

export const createSessionStorage = (options: Options = {}) => {
  return createStorage(createOptions(sessionStorage, options))
}

export const createLocalStorage = (options: Options = {}) => {
  return createStorage(createOptions(localStorage, options))
}

export default WebStorage
